<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title> {{"MASCHINESTATE.CURRENTS.HEADER_MULTI" | translate}}</mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <div class="stack-wrapper">
                        <div class="background stack" id="wrapper">
                            <img
                                class="cabine-background"
                                id="image"
                                src="../../../../../../assets/images/machine/multi/360G_SW_aus.svg"
                                alt=""
                                (load)="this.imgLoaded = true"
                            />
                        </div>

                        <ng-container *ngIf="this.imgLoaded == true">

                            <!-- Driving Values-->
                            <div class="value-block amp stack" id="drive">
                                <div class="value-block-title">{{"MASCHINESTATE.CURRENTS.DRIVE" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentCurrentsDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Undercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Machine Values-->
                            <div class="value-block amp stack" id="machine">
                                <div class="value-block-title">{{"MASCHINESTATE.CURRENTS.MACHINE" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentCurrentsDataset.dataPoints">
                                    <ng-container *ngIf="datapoint.position == this.positionEnum.Engine_Uppercarriage">
                                        <div class="datapoint borderred" id="wrapper">
                                            <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                            <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                </div>
                            </div>

                            <!-- Boom Cylinder Values-->
                            <div class="value-block amp stack" id="boom-cylinder">
                                <div class="value-block-title">{{"MASCHINESTATE.CURRENTS.BOOM" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentCurrentsDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Boom">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Equipment Values-->
                            <div class="value-block amp stack" id="equipment">
                                <div class="value-block-title">{{"MASCHINESTATE.CURRENTS.EQUIPMENT" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentCurrentsDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Equipment">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Hydraulic Values-->
                            <div class="value-block amp stack" id="hydraulic">
                                <div class="value-block-title">{{"MASCHINESTATE.CURRENTS.HYDRAULIC" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentCurrentsDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Hydraulic_Addition">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
